export const truncate = (text, num = 10) => {
  if (text.length > num) {
    return `${text.substring(0, num - 3)}...`;
  }
  return text;
};
export const toTop = () => {
  window.scroll({ top: 0, left: 0, behavior: "smooth" });
};
